const DashboardPage = () => {
  return (
    <div style={{ padding: "40px 32px" }}>
      <div
        style={{
          width: "64px",
          height: "64px",
          backgroundColor: "#006657",
          WebkitMaskImage: "url('/smart-logo-no-text-white.webp')",
          maskImage: "url('/smart-logo-no-text-white.webp')",
          WebkitMaskSize: "contain",
          maskSize: "contain",
          WebkitMaskRepeat: "no-repeat",
          maskRepeat: "no-repeat",
          WebkitMaskPosition: "center",
          maskPosition: "center",
          marginBottom: "16px",
        }}
      />
      <p style={{ margin: "0 0 8px 0", color: "var(--theme-text)", fontSize: "1.1rem" }}>
        Bienvenido de nuevo,
      </p>
      <h1
        style={{
          margin: "0 0 4px 0",
          fontWeight: "700",
          color: "var(--theme-text)",
          borderLeft: "4px solid #006657",
          paddingLeft: "12px",
        }}
      >
        Administración de SmartDoc
      </h1>
      <p style={{ margin: "20px 0 0 0", color: "var(--theme-text)", fontSize: "1rem" }}>
        Seleccione una opción de la barra de navegación izquierda para comenzar.
      </p>
    </div>
  );
};

export default DashboardPage;
